import { FormInstance } from "antd/es/form";
import _ from "lodash";
import React from "react";
import { IUserInfoDto } from "../../models/dto/user-info.dto";
import { IValidationData } from "../../models/dto/validation-data";
import { UserService } from "../../services/user-service";
import { KContext } from "../../shared/hoc/with-context";
import { KNavigator } from "../../shared/hoc/with-history";
import { KuikaAppManager } from "../../shared/utilty/kuika-app-manager";
import { KMainFunctions } from "../../shared/utilty/main-functions";
import { ReactSystemFunctions } from "../../shared/utilty/react-system-functions";

declare let window: any;

export interface IYuklemeListesiv2EvrakKontrolTedarikci_ScreenProps {
  navigator: KNavigator;
  form: FormInstance<any>;
  googleLogin: any;
  screenInputs: any;
  context: KContext;
  initialValues: any;
  children: any;
}

interface IYuklemeListesiv2EvrakKontrolTedarikci_ScreenState {
  isSpinnerVisible: boolean;
  isPageVisible: boolean;
  isLeftMenuVisible: boolean;
  spinnerCount: number;
  selectedLanguage: string;
  isPageInitLoaded: false;
  isPageRecurringLoaded: false;
  NAVIGATE: any;
  NAVIGATE_dummy: any;
  ReadFromSessionStorage: string;
  ReadFromSessionStorage_dummy: string;
  Get_Helpers_UserInfoByUserName: any[];
  Get_Helpers_UserInfoByUserName_dummy: any[];
  Get_Date: any[];
  Get_Date_dummy: any[];
  SetValueOf: any;
  SetValueOf_dummy: any;
  YuklemePlan_Get_EvrakKontrolListe_Tedarikci: any[];
  YuklemePlan_Get_EvrakKontrolListe_Tedarikci_dummy: any[];
  ExportExcel: any;
  ExportExcel_dummy: any;
  isComp669805Enabled: "enabled" | "disabled";
  isComp857415Enabled: "enabled" | "disabled";
  isComp687459Enabled: "enabled" | "disabled";
}

export class YuklemeListesiv2EvrakKontrolTedarikci_ScreenBase extends React.PureComponent<
  IYuklemeListesiv2EvrakKontrolTedarikci_ScreenProps,
  any
> {
  yuklemelistesiv2evrakkontroltedarikci_129888_value_kuikaDateRef: React.RefObject<any>;
  yuklemelistesiv2evrakkontroltedarikci_140956_value_kuikaDateRef: React.RefObject<any>;
  yuklemelistesiv2evrakkontroltedarikci_559033_value_kuikaTableRef: React.RefObject<any>;
  yuklemelistesiv2evrakkontroltedarikci_669805_value_kuikaDateRef: React.RefObject<any>;
  yuklemelistesiv2evrakkontroltedarikci_857415_value_kuikaDateRef: React.RefObject<any>;
  yuklemelistesiv2evrakkontroltedarikci_687459_value_kuikaDateRef: React.RefObject<any>;
  ml = [
    {
      Id: "585b6303-ac4a-473f-8893-c915ede3bf84",
      Name: "en_US",
      ShortName: "English",
      IsDefault: true,
      LanguagePhrases: [],
    },
    {
      Id: "9586d748-9aac-4bde-80e5-a46f833208f0",
      Name: "FixedValues",
      ShortName: "FixedValues",
      LanguagePhrases: [
        {
          Id: 980166,
          PropertyName: "value",
          Value: "Aruna Nakliye Yönetim Portalı",
        },
        {
          Id: 162294,
          PropertyName: "value",
          Value: "TESLİMAT EVRAK KONTROL EKRANI",
        },
        { Id: 186535, PropertyName: "label", Value: "Excel Kaydet" },
        { Id: 755618, PropertyName: "value", Value: "TARİH ARALIĞI SEÇİNİZ" },
        { Id: 129888, PropertyName: "placeholder", Value: "Select Date..." },
        { Id: 140956, PropertyName: "placeholder", Value: "Select Date..." },
        { Id: 111189, PropertyName: "label", Value: "Yenile" },
        { Id: 145261, PropertyName: "title", Value: "İşlemler" },
        { Id: 499902, PropertyName: "title", Value: "Tarih" },
        { Id: 669805, PropertyName: "placeholder", Value: "Select Date..." },
        { Id: 510557, PropertyName: "title", Value: "Ref Yükleme No" },
        {
          Id: 918217,
          PropertyName: "value",
          Value: "[datafield:referansyuklemeno]",
        },
        { Id: 408516, PropertyName: "title", Value: "Yükleme No" },
        { Id: 307294, PropertyName: "value", Value: "[datafield:yuklemeno]" },
        { Id: 705838, PropertyName: "title", Value: "Teslimat No" },
        { Id: 290148, PropertyName: "value", Value: "[datafield:teslimatno]" },
        { Id: 6315, PropertyName: "title", Value: "Müşteri Adı" },
        { Id: 283400, PropertyName: "value", Value: "[datafield:musteriadi]" },
        { Id: 42704, PropertyName: "title", Value: "Taşıyıcı Firma" },
        {
          Id: 730621,
          PropertyName: "value",
          Value: "[datafield:tasiyicifirmaadi]",
        },
        {
          Id: 679415,
          PropertyName: "title",
          Value: "Gerçekleşen Yükleme Tarihi",
        },
        { Id: 857415, PropertyName: "placeholder", Value: "Select Date..." },
        { Id: 995104, PropertyName: "title", Value: "Teslim Tarihi" },
        { Id: 687459, PropertyName: "placeholder", Value: "Select Date..." },
        { Id: 670146, PropertyName: "title", Value: "Teslimat Süresi" },
        {
          Id: 184432,
          PropertyName: "value",
          Value: "[datafield:teslimatsuresigun]",
        },
        { Id: 768361, PropertyName: "title", Value: "Yüklenen Evrak Adedi" },
        {
          Id: 804461,
          PropertyName: "value",
          Value: "[datafield:yuklenmisevraksayisi]",
        },
        { Id: 619123, PropertyName: "title", Value: "Plaka" },
        { Id: 924550, PropertyName: "value", Value: "[datafield:plaka]" },
        { Id: 440379, PropertyName: "title", Value: "Sürücü Adı" },
        { Id: 14457, PropertyName: "value", Value: "[datafield:surucuadi]" },
        { Id: 997454, PropertyName: "title", Value: "Sürücü Gsm" },
        { Id: 434788, PropertyName: "value", Value: "[datafield:surucugsm]" },
        { Id: 725710, PropertyName: "title", Value: "Durum" },
        { Id: 929844, PropertyName: "value", Value: "[datafield:durum]" },
        { Id: 349057, PropertyName: "title", Value: "İrsaliye No" },
        { Id: 624672, PropertyName: "value", Value: "[datafield:irsaliyeno]" },
        { Id: 677348, PropertyName: "title", Value: "FaturaNo" },
        { Id: 267140, PropertyName: "value", Value: "[datafield:faturano]" },
        { Id: 643374, PropertyName: "title", Value: "E-Fatura No" },
        { Id: 458377, PropertyName: "value", Value: "[datafield:efaturano]" },
        { Id: 614599, PropertyName: "title", Value: "İade Var" },
      ],
    },
  ];
  defaultML = "en_US";

  screenHash = "";

  constructor(props) {
    super(props);
    this.yuklemelistesiv2evrakkontroltedarikci_129888_value_kuikaDateRef =
      React.createRef();
    this.yuklemelistesiv2evrakkontroltedarikci_140956_value_kuikaDateRef =
      React.createRef();
    this.yuklemelistesiv2evrakkontroltedarikci_559033_value_kuikaTableRef =
      React.createRef();
    this.yuklemelistesiv2evrakkontroltedarikci_669805_value_kuikaDateRef =
      React.createRef();
    this.yuklemelistesiv2evrakkontroltedarikci_857415_value_kuikaDateRef =
      React.createRef();
    this.yuklemelistesiv2evrakkontroltedarikci_687459_value_kuikaDateRef =
      React.createRef();

    this.state = {
      isSpinnerVisible: false,
      isPageVisible: false,
      isLeftMenuVisible: false,
      spinnerCount: 0,
      selectedLanguage: "",
      isPageInitLoaded: false,
      isPageRecurringLoaded: false,
      NAVIGATE: "",
      ReadFromSessionStorage: "",
      Get_Helpers_UserInfoByUserName: [],
      Get_Date: [],
      SetValueOf: "",
      YuklemePlan_Get_EvrakKontrolListe_Tedarikci: [],
      ExportExcel: "",
      isComp669805Enabled: "disabled",
      isComp857415Enabled: "disabled",
      isComp687459Enabled: "disabled",
    };

    this.CheckPageAuthorization(this.state);
  }

  async componentDidMount() {
    if (KuikaAppManager.isPageInitPrevented()) {
      KuikaAppManager.calculateAndSetBodyHeight(
        "yuklemelistesiv2evrakkontroltedarikci",
        ""
      );
      return;
    }

    ReactSystemFunctions.validateToken();
    this.fillFormInitValues();
    if (true) {
      await this.YuklemeListesiv2EvrakKontrolTedarikciPageInit();
    }

    KuikaAppManager.calculateAndSetBodyHeight(
      "yuklemelistesiv2evrakkontroltedarikci",
      ""
    );

    if (ReactSystemFunctions.getIsMicroApp() === false) {
      window.parentScreen = this;
    }
  }

  componentWillUnmount() {
    if (ReactSystemFunctions.getIsMicroApp() === false) {
      window.parentScreen = null;
    }
  }

  CheckPageAuthorization = async (state) => {
    KuikaAppManager.showSpinner(this);
    if (_.isEmpty(window.userInfo)) {
      await UserService.GetUserInfoForce();
    }
    const permittedRoleNames: string[] = ["Tedarikci"];
    const userInfo = window.userInfo as IUserInfoDto;
    const userRoleNames = userInfo.roles.map((role) => role.name);
    if (
      !permittedRoleNames.some((roleName) => userRoleNames.includes(roleName))
    ) {
      await ReactSystemFunctions.goBack(this);

      const language = localStorage.getItem("ml");
      let permissonErrorMessageText =
        "You do not have permission to access this page.";
      if (language === "tr_TR") {
        permissonErrorMessageText = "Bu sayfaya erişim yetkiniz yok.";
      } else if (language === "fr_FR") {
        permissonErrorMessageText =
          "Vous n'avez pas la permission d'accéder à cette page.";
      } else if (language === "de_DE") {
        permissonErrorMessageText =
          "Sie haben keine Berechtigung, auf diese Seite zuzugreifen.";
      } else if (language === "es_ES") {
        permissonErrorMessageText =
          "No tienes permiso para acceder a esta página.";
      }

      KMainFunctions.displayErrorNotification(permissonErrorMessageText);
      state.isPageVisible = false;
      KuikaAppManager.hideSpinner(this);
      return;
    }
    state.isPageVisible = true;
    KuikaAppManager.hideSpinner(this);
  };

  componentDidUpdate = async (prevProps, prevState) => {
    KuikaAppManager.calculateAndSetBodyHeight(
      "yuklemelistesiv2evrakkontroltedarikci",
      ""
    );
    if (prevProps?.location?.search !== (this.props as any)?.location?.search) {
      await this.YuklemeListesiv2EvrakKontrolTedarikciPageInit();
    }

    if (ReactSystemFunctions.getIsMicroApp() === false) {
      for (const key in prevState) {
        if (
          key.startsWith("NavVisible") &&
          prevState[key] === true &&
          this.state[key] === false
        ) {
          window.parentScreen = this;
          break;
        }
      }
    }
  };

  fillFormInitValues() {
    this.props.form?.setFieldsValue({});
  }

  setPageInitLoaded = (value: boolean) => {
    this.setState({ isPageInitLoaded: value });
  };

  setPageRecurringLoaded = (value: boolean) => {
    this.setState({ isPageRecurringLoaded: value });
  };

  clearFieldValidation = (changedValues: any) => {
    const fieldName = Object.keys(changedValues)[0];
    if (fieldName) {
      this.props.form?.setFields([
        {
          name: fieldName,
          errors: [],
        },
      ]);
    }
  };

  YuklemeListesiv2EvrakKontrolTedarikciPageInit = async () => {
    let stateVars = {} as any;
    let formVars = {} as any;
    let validations = [] as IValidationData[];
    let isErrorOccurred = false;

    if (KuikaAppManager.handleValidations(this, validations)) {
      const invalidValidation = validations.find(
        (v) => !v.isValid && v.condition
      );
      if (invalidValidation) {
        const formName = invalidValidation?.formName;
        const fieldId = formName?.match(/\d+/)?.[0];
        if (!formName || !fieldId) return;

        const applyError = () =>
          this.props.form?.setFields([
            {
              name: formName,
              errors: [invalidValidation.message],
              touched: true,
            },
          ]);

        applyError();
      }
      return true;
    }
    KuikaAppManager.showSpinner(this);

    stateVars.ReadFromSessionStorage =
      await ReactSystemFunctions.readFromSessionStorage(
        ReactSystemFunctions.convertToTypeByName("FirmaNo", "string")
      );

    this.props.form?.setFieldsValue(formVars);

    await new Promise((resolve, reject) => {
      this.setState(stateVars, async () => {
        isErrorOccurred =
          await this.YuklemeListesiv2EvrakKontrolTedarikciPageInit1_();
        resolve();
      });
    });

    return isErrorOccurred;
  };
  YuklemeListesiv2EvrakKontrolTedarikciPageInit1_ = async () => {
    let stateVars = {} as any;
    let formVars = {} as any;
    let validations = [] as IValidationData[];
    let isErrorOccurred = false;

    if (KuikaAppManager.handleValidations(this, validations)) {
      const invalidValidation = validations.find(
        (v) => !v.isValid && v.condition
      );
      if (invalidValidation) {
        const formName = invalidValidation?.formName;
        const fieldId = formName?.match(/\d+/)?.[0];
        if (!formName || !fieldId) return;

        const applyError = () =>
          this.props.form?.setFields([
            {
              name: formName,
              errors: [invalidValidation.message],
              touched: true,
            },
          ]);

        applyError();
      }
      return true;
    }

    let localVar = {
      UserName_0: ReactSystemFunctions.convertToTypeByName(
        ReactSystemFunctions.getMyUsername(),
        "string"
      ),
    };

    if (true) {
      KuikaAppManager.showSpinner(this);
    }
    let result = await KuikaAppManager.ApiRequest(
      this,
      "YuklemeListesiv2EvrakKontrolTedarikci/YuklemeListesiv2EvrakKontrolTedarikciPageInit1_",
      localVar
    );
    if (!KMainFunctions.IsResStatus2XX(result)) return true;

    stateVars.Get_Helpers_UserInfoByUserName =
      result?.data.get_Helpers_UserInfoByUserName;
    stateVars.Get_Date = result?.data.get_Date;
    this.props.form?.setFieldsValue(formVars);

    await new Promise((resolve, reject) => {
      this.setState(stateVars, async () => {
        isErrorOccurred =
          await this.YuklemeListesiv2EvrakKontrolTedarikciPageInit2_();
        resolve();
      });
    });

    KuikaAppManager.hideSpinner(this);
    return isErrorOccurred;
  };
  YuklemeListesiv2EvrakKontrolTedarikciPageInit2_ = async () => {
    let stateVars = {} as any;
    let formVars = {} as any;
    let validations = [] as IValidationData[];
    let isErrorOccurred = false;

    if (KuikaAppManager.handleValidations(this, validations)) {
      const invalidValidation = validations.find(
        (v) => !v.isValid && v.condition
      );
      if (invalidValidation) {
        const formName = invalidValidation?.formName;
        const fieldId = formName?.match(/\d+/)?.[0];
        if (!formName || !fieldId) return;

        const applyError = () =>
          this.props.form?.setFields([
            {
              name: formName,
              errors: [invalidValidation.message],
              touched: true,
            },
          ]);

        applyError();
      }
      return true;
    }

    stateVars.SetValueOf = await ReactSystemFunctions.setValueOf(
      this,
      ReactSystemFunctions.convertToTypeByName(
        "yuklemelistesiv2evrakkontroltedarikci_129888_value",
        "string"
      ),
      ReactSystemFunctions.value(
        this,
        stateVars.Get_Date !== undefined
          ? stateVars.Get_Date?.length > 0
            ? stateVars.Get_Date[0].ayIlkGun
            : null
          : this.state.Get_Date?.length > 0
          ? this.state.Get_Date[0].ayIlkGun
          : null
      ),
      null,
      false
    );
    stateVars.SetValueOf = await ReactSystemFunctions.setValueOf(
      this,
      ReactSystemFunctions.convertToTypeByName(
        "yuklemelistesiv2evrakkontroltedarikci_140956_value",
        "string"
      ),
      ReactSystemFunctions.value(
        this,
        stateVars.Get_Date !== undefined
          ? stateVars.Get_Date?.length > 0
            ? stateVars.Get_Date[0].aySonGun
            : null
          : this.state.Get_Date?.length > 0
          ? this.state.Get_Date[0].aySonGun
          : null
      ),
      null,
      false
    );

    this.props.form?.setFieldsValue(formVars);

    await new Promise((resolve, reject) => {
      this.setState(stateVars, async () => {
        isErrorOccurred =
          await this.YuklemeListesiv2EvrakKontrolTedarikciPageInit3_();
        resolve();
      });
    });

    return isErrorOccurred;
  };
  YuklemeListesiv2EvrakKontrolTedarikciPageInit3_ = async () => {
    let stateVars = {} as any;
    let formVars = {} as any;
    let validations = [] as IValidationData[];
    let isErrorOccurred = false;

    if (KuikaAppManager.handleValidations(this, validations)) {
      const invalidValidation = validations.find(
        (v) => !v.isValid && v.condition
      );
      if (invalidValidation) {
        const formName = invalidValidation?.formName;
        const fieldId = formName?.match(/\d+/)?.[0];
        if (!formName || !fieldId) return;

        const applyError = () =>
          this.props.form?.setFields([
            {
              name: formName,
              errors: [invalidValidation.message],
              touched: true,
            },
          ]);

        applyError();
      }
      return true;
    }

    let localVar = {
      BagliFirmaId_0: ReactSystemFunctions.convertToTypeByName(
        ReactSystemFunctions.value(
          this,
          stateVars.Get_Helpers_UserInfoByUserName !== undefined
            ? stateVars.Get_Helpers_UserInfoByUserName?.length > 0
              ? stateVars.Get_Helpers_UserInfoByUserName[0].bagliFirmaId
              : null
            : this.state.Get_Helpers_UserInfoByUserName?.length > 0
            ? this.state.Get_Helpers_UserInfoByUserName[0].bagliFirmaId
            : null
        ),
        "Guid"
      ),
      UserRole_0: ReactSystemFunctions.convertToTypeByName(
        ReactSystemFunctions.toString(
          this,
          stateVars.Get_Helpers_UserInfoByUserName !== undefined
            ? stateVars.Get_Helpers_UserInfoByUserName?.length > 0
              ? stateVars.Get_Helpers_UserInfoByUserName[0].rolName
              : null
            : this.state.Get_Helpers_UserInfoByUserName?.length > 0
            ? this.state.Get_Helpers_UserInfoByUserName[0].rolName
            : null
        ),
        "string"
      ),
    };

    if (true) {
      KuikaAppManager.showSpinner(this);
    }
    let result = await KuikaAppManager.ApiRequest(
      this,
      "YuklemeListesiv2EvrakKontrolTedarikci/YuklemeListesiv2EvrakKontrolTedarikciPageInit3_",
      localVar
    );
    if (!KMainFunctions.IsResStatus2XX(result)) return true;

    stateVars.YuklemePlan_Get_EvrakKontrolListe_Tedarikci =
      result?.data.yuklemePlan_Get_EvrakKontrolListe_Tedarikci;

    this.props.form?.setFieldsValue(formVars);

    await new Promise((resolve, reject) => {
      this.setState(stateVars, async () => {
        isErrorOccurred =
          await this.YuklemeListesiv2EvrakKontrolTedarikciPageInit4_();
        resolve();
      });
    });

    KuikaAppManager.hideSpinner(this);
    return isErrorOccurred;
  };
  YuklemeListesiv2EvrakKontrolTedarikciPageInit4_ = async () => {
    let stateVars = {} as any;
    let formVars = {} as any;
    let validations = [] as IValidationData[];
    let isErrorOccurred = false;

    if (KuikaAppManager.handleValidations(this, validations)) {
      const invalidValidation = validations.find(
        (v) => !v.isValid && v.condition
      );
      if (invalidValidation) {
        const formName = invalidValidation?.formName;
        const fieldId = formName?.match(/\d+/)?.[0];
        if (!formName || !fieldId) return;

        const applyError = () =>
          this.props.form?.setFields([
            {
              name: formName,
              errors: [invalidValidation.message],
              touched: true,
            },
          ]);

        applyError();
      }
      return true;
    }

    stateVars.dataSource_559033 =
      stateVars.YuklemePlan_Get_EvrakKontrolListe_Tedarikci ??
      this.state.YuklemePlan_Get_EvrakKontrolListe_Tedarikci;

    this.props.form?.setFieldsValue(formVars);
    this.setState(stateVars);
    KuikaAppManager.hideSpinner(this);

    this.setPageInitLoaded(true);
    return isErrorOccurred;
  };

  YuklemeListesiv2EvrakKontrolTedarikciComponent_834167_onClick = async () => {
    let stateVars = {} as any;
    let formVars = {} as any;
    let validations = [] as IValidationData[];
    let isErrorOccurred = false;

    if (KuikaAppManager.handleValidations(this, validations)) {
      const invalidValidation = validations.find(
        (v) => !v.isValid && v.condition
      );
      if (invalidValidation) {
        const formName = invalidValidation?.formName;
        const fieldId = formName?.match(/\d+/)?.[0];
        if (!formName || !fieldId) return;

        const applyError = () =>
          this.props.form?.setFields([
            {
              name: formName,
              errors: [invalidValidation.message],
              touched: true,
            },
          ]);

        applyError();
      }
      return true;
    }
    if (
      ReactSystemFunctions.isEqualTo(
        ReactSystemFunctions.value(
          this,
          stateVars.Get_Helpers_UserInfoByUserName !== undefined
            ? stateVars.Get_Helpers_UserInfoByUserName?.length > 0
              ? stateVars.Get_Helpers_UserInfoByUserName[0].firmaTipi
              : null
            : this.state.Get_Helpers_UserInfoByUserName?.length > 0
            ? this.state.Get_Helpers_UserInfoByUserName[0].firmaTipi
            : null
        ),
        "1"
      )
    ) {
      KuikaAppManager.showSpinner(this);

      KuikaAppManager.prepareForNavigation();

      stateVars.NAVIGATE = await ReactSystemFunctions.navigate(
        this,
        this.YuklemeListesiv2EvrakKontrolTedarikciComponent_834167_onClick1_,
        "YuklemeListesiv2EvrakKontrolTedarikci",
        "LeftMenu",
        "",
        "7d969ddf-5801-4eb6-b92b-12be35bdd565",
        "690718",
        null,
        "left",
        "true",
        "380px",
        "100vh",
        true,
        false
      );

      this.props.form?.setFieldsValue(formVars);
      this.setState(stateVars);
    } else {
      await new Promise((resolve, reject) => {
        this.setState(stateVars, async () => {
          isErrorOccurred =
            await this.YuklemeListesiv2EvrakKontrolTedarikciComponent_834167_onClick1_();
          resolve();
        });
      });
    }

    return isErrorOccurred;
  };
  YuklemeListesiv2EvrakKontrolTedarikciComponent_834167_onClick1_ =
    async () => {
      let stateVars = {} as any;
      let formVars = {} as any;
      let validations = [] as IValidationData[];
      let isErrorOccurred = false;

      if (KuikaAppManager.handleValidations(this, validations)) {
        const invalidValidation = validations.find(
          (v) => !v.isValid && v.condition
        );
        if (invalidValidation) {
          const formName = invalidValidation?.formName;
          const fieldId = formName?.match(/\d+/)?.[0];
          if (!formName || !fieldId) return;

          const applyError = () =>
            this.props.form?.setFields([
              {
                name: formName,
                errors: [invalidValidation.message],
                touched: true,
              },
            ]);

          applyError();
        }
        return true;
      }
      if (
        ReactSystemFunctions.isEqualTo(
          ReactSystemFunctions.value(
            this,
            stateVars.Get_Helpers_UserInfoByUserName !== undefined
              ? stateVars.Get_Helpers_UserInfoByUserName?.length > 0
                ? stateVars.Get_Helpers_UserInfoByUserName[0].firmaTipi
                : null
              : this.state.Get_Helpers_UserInfoByUserName?.length > 0
              ? this.state.Get_Helpers_UserInfoByUserName[0].firmaTipi
              : null
          ),
          "2"
        )
      ) {
        KuikaAppManager.prepareForNavigation();

        stateVars.NAVIGATE = await ReactSystemFunctions.navigate(
          this,
          undefined,
          "YuklemeListesiv2EvrakKontrolTedarikci",
          "LeftMenuYukVeren",
          "",
          "7d969ddf-5801-4eb6-b92b-12be35bdd565",
          "375410",
          null,
          "left",
          "true",
          "380px",
          "100vh",
          true,
          false
        );

        this.props.form?.setFieldsValue(formVars);
        this.setState(stateVars);
        KuikaAppManager.hideSpinner(this);
      } else {
        KuikaAppManager.hideSpinner(this);
      }

      return isErrorOccurred;
    };

  YuklemeListesiv2EvrakKontrolTedarikciComponent_186535_onClick = async () => {
    let stateVars = {} as any;
    let formVars = {} as any;
    let validations = [] as IValidationData[];
    let isErrorOccurred = false;

    if (KuikaAppManager.handleValidations(this, validations)) {
      const invalidValidation = validations.find(
        (v) => !v.isValid && v.condition
      );
      if (invalidValidation) {
        const formName = invalidValidation?.formName;
        const fieldId = formName?.match(/\d+/)?.[0];
        if (!formName || !fieldId) return;

        const applyError = () =>
          this.props.form?.setFields([
            {
              name: formName,
              errors: [invalidValidation.message],
              touched: true,
            },
          ]);

        applyError();
      }
      return true;
    }
    KuikaAppManager.increaseServerRequestCount();

    let localVar = {
      BagliFirmaId_0: ReactSystemFunctions.convertToTypeByName(
        ReactSystemFunctions.value(
          this,
          stateVars.Get_Helpers_UserInfoByUserName !== undefined
            ? stateVars.Get_Helpers_UserInfoByUserName?.length > 0
              ? stateVars.Get_Helpers_UserInfoByUserName[0].bagliFirmaId
              : null
            : this.state.Get_Helpers_UserInfoByUserName?.length > 0
            ? this.state.Get_Helpers_UserInfoByUserName[0].bagliFirmaId
            : null
        ),
        "Guid"
      ),
      UserRole_0: ReactSystemFunctions.convertToTypeByName(
        ReactSystemFunctions.toString(
          this,
          stateVars.Get_Helpers_UserInfoByUserName !== undefined
            ? stateVars.Get_Helpers_UserInfoByUserName?.length > 0
              ? stateVars.Get_Helpers_UserInfoByUserName[0].rolName
              : null
            : this.state.Get_Helpers_UserInfoByUserName?.length > 0
            ? this.state.Get_Helpers_UserInfoByUserName[0].rolName
            : null
        ),
        "string"
      ),
      value_1: ReactSystemFunctions.convertToTypeByName(
        ReactSystemFunctions.value(
          this,
          stateVars.YuklemePlan_Get_EvrakKontrolListe_Tedarikci
        ),
        "any"
      ),
      header_1: ReactSystemFunctions.convertToTypeByName(
        ReactSystemFunctions.convertToTypeByName("YÜKLEME LİSTESİ", "string"),
        "string"
      ),
      footer_1: ReactSystemFunctions.convertToTypeByName("", "string"),
      columns_1: ReactSystemFunctions.convertToTypeByName(
        ReactSystemFunctions.convertToTypeByName("", "string"),
        "string"
      ),
    };

    KuikaAppManager.showSpinner(this);

    if (true) {
      KuikaAppManager.showSpinner(this);
    }
    let result = await KuikaAppManager.ApiRequest(
      this,
      "YuklemeListesiv2EvrakKontrolTedarikci/YuklemeListesiv2EvrakKontrolTedarikciComponent_186535_onClick",
      localVar
    );
    if (!KMainFunctions.IsResStatus2XX(result)) return true;

    stateVars.YuklemePlan_Get_EvrakKontrolListe_Tedarikci =
      result?.data.yuklemePlan_Get_EvrakKontrolListe_Tedarikci;

    stateVars.ExportExcel = result?.data.exportExcel;
    ReactSystemFunctions.downloadFile(result?.data?.exportExcel);
    this.props.form?.setFieldsValue(formVars);

    await new Promise((resolve, reject) => {
      this.setState(stateVars, async () => {
        isErrorOccurred =
          await this.YuklemeListesiv2EvrakKontrolTedarikciComponent_186535_onClick1_();
        resolve();
      });
    });

    KuikaAppManager.hideSpinner(this);
    return isErrorOccurred;
  };
  YuklemeListesiv2EvrakKontrolTedarikciComponent_186535_onClick1_ =
    async () => {
      let stateVars = {} as any;
      let formVars = {} as any;
      let validations = [] as IValidationData[];
      let isErrorOccurred = false;

      if (KuikaAppManager.handleValidations(this, validations)) {
        const invalidValidation = validations.find(
          (v) => !v.isValid && v.condition
        );
        if (invalidValidation) {
          const formName = invalidValidation?.formName;
          const fieldId = formName?.match(/\d+/)?.[0];
          if (!formName || !fieldId) return;

          const applyError = () =>
            this.props.form?.setFields([
              {
                name: formName,
                errors: [invalidValidation.message],
                touched: true,
              },
            ]);

          applyError();
        }
        return true;
      }

      stateVars.dataSource_559033 =
        stateVars.YuklemePlan_Get_EvrakKontrolListe_Tedarikci ??
        this.state.YuklemePlan_Get_EvrakKontrolListe_Tedarikci;

      this.props.form?.setFieldsValue(formVars);
      this.setState(stateVars);
      KuikaAppManager.hideSpinner(this);

      return isErrorOccurred;
    };

  YuklemeListesiv2EvrakKontrolTedarikciComponent_111189_onClick = async () => {
    let stateVars = {} as any;
    let formVars = {} as any;
    let validations = [] as IValidationData[];
    let isErrorOccurred = false;

    if (KuikaAppManager.handleValidations(this, validations)) {
      const invalidValidation = validations.find(
        (v) => !v.isValid && v.condition
      );
      if (invalidValidation) {
        const formName = invalidValidation?.formName;
        const fieldId = formName?.match(/\d+/)?.[0];
        if (!formName || !fieldId) return;

        const applyError = () =>
          this.props.form?.setFields([
            {
              name: formName,
              errors: [invalidValidation.message],
              touched: true,
            },
          ]);

        applyError();
      }
      return true;
    }
    KuikaAppManager.increaseServerRequestCount();

    let localVar = {
      BagliFirmaId_0: ReactSystemFunctions.convertToTypeByName(
        ReactSystemFunctions.value(
          this,
          stateVars.Get_Helpers_UserInfoByUserName !== undefined
            ? stateVars.Get_Helpers_UserInfoByUserName?.length > 0
              ? stateVars.Get_Helpers_UserInfoByUserName[0].bagliFirmaId
              : null
            : this.state.Get_Helpers_UserInfoByUserName?.length > 0
            ? this.state.Get_Helpers_UserInfoByUserName[0].bagliFirmaId
            : null
        ),
        "Guid"
      ),
      UserRole_0: ReactSystemFunctions.convertToTypeByName(
        ReactSystemFunctions.toString(
          this,
          stateVars.Get_Helpers_UserInfoByUserName !== undefined
            ? stateVars.Get_Helpers_UserInfoByUserName?.length > 0
              ? stateVars.Get_Helpers_UserInfoByUserName[0].rolName
              : null
            : this.state.Get_Helpers_UserInfoByUserName?.length > 0
            ? this.state.Get_Helpers_UserInfoByUserName[0].rolName
            : null
        ),
        "string"
      ),
    };

    KuikaAppManager.showSpinner(this);

    if (true) {
      KuikaAppManager.showSpinner(this);
    }
    let result = await KuikaAppManager.ApiRequest(
      this,
      "YuklemeListesiv2EvrakKontrolTedarikci/YuklemeListesiv2EvrakKontrolTedarikciComponent_111189_onClick",
      localVar
    );
    if (!KMainFunctions.IsResStatus2XX(result)) return true;

    stateVars.YuklemePlan_Get_EvrakKontrolListe_Tedarikci =
      result?.data.yuklemePlan_Get_EvrakKontrolListe_Tedarikci;

    this.props.form?.setFieldsValue(formVars);

    await new Promise((resolve, reject) => {
      this.setState(stateVars, async () => {
        isErrorOccurred =
          await this.YuklemeListesiv2EvrakKontrolTedarikciComponent_111189_onClick1_();
        resolve();
      });
    });

    KuikaAppManager.hideSpinner(this);
    return isErrorOccurred;
  };
  YuklemeListesiv2EvrakKontrolTedarikciComponent_111189_onClick1_ =
    async () => {
      let stateVars = {} as any;
      let formVars = {} as any;
      let validations = [] as IValidationData[];
      let isErrorOccurred = false;

      if (KuikaAppManager.handleValidations(this, validations)) {
        const invalidValidation = validations.find(
          (v) => !v.isValid && v.condition
        );
        if (invalidValidation) {
          const formName = invalidValidation?.formName;
          const fieldId = formName?.match(/\d+/)?.[0];
          if (!formName || !fieldId) return;

          const applyError = () =>
            this.props.form?.setFields([
              {
                name: formName,
                errors: [invalidValidation.message],
                touched: true,
              },
            ]);

          applyError();
        }
        return true;
      }

      stateVars.dataSource_559033 =
        stateVars.YuklemePlan_Get_EvrakKontrolListe_Tedarikci ??
        this.state.YuklemePlan_Get_EvrakKontrolListe_Tedarikci;

      this.props.form?.setFieldsValue(formVars);
      this.setState(stateVars);
      KuikaAppManager.hideSpinner(this);

      return isErrorOccurred;
    };

  YuklemeListesiv2EvrakKontrolTedarikciComponent_535229_onClick = async () => {
    let stateVars = {} as any;
    let formVars = {} as any;
    let validations = [] as IValidationData[];
    let isErrorOccurred = false;

    if (KuikaAppManager.handleValidations(this, validations)) {
      const invalidValidation = validations.find(
        (v) => !v.isValid && v.condition
      );
      if (invalidValidation) {
        const formName = invalidValidation?.formName;
        const fieldId = formName?.match(/\d+/)?.[0];
        if (!formName || !fieldId) return;

        const applyError = () =>
          this.props.form?.setFields([
            {
              name: formName,
              errors: [invalidValidation.message],
              touched: true,
            },
          ]);

        applyError();
      }
      return true;
    }
    KuikaAppManager.showSpinner(this);

    KuikaAppManager.prepareForNavigation();
    KuikaAppManager.addToPageInputVariables(
      "YuklemeListesiv2EvrakDetayTedarikci",
      "YuklemeId",
      ReactSystemFunctions.convertToTypeByName(
        ReactSystemFunctions.value(
          this,
          "yuklemelistesiv2evrakkontroltedarikci_559033_value",
          "yuklemeId"
        ),
        "Guid"
      )
    );
    KuikaAppManager.addToPageInputVariables(
      "YuklemeListesiv2EvrakDetayTedarikci",
      "TeslimatNo",
      ReactSystemFunctions.convertToTypeByName(
        ReactSystemFunctions.value(
          this,
          "yuklemelistesiv2evrakkontroltedarikci_559033_value",
          "teslimatNo"
        ),
        "number"
      )
    );

    stateVars.NAVIGATE = await ReactSystemFunctions.navigate(
      this,
      undefined,
      "YuklemeListesiv2EvrakKontrolTedarikci",
      "YuklemeListesiv2EvrakDetayTedarikci",
      "",
      "9924ef5f-4b84-4200-b624-8d76348c7686",
      "210645",
      null,
      null,
      "true",
      "80vw",
      "85vh",
      true,
      false
    );

    this.props.form?.setFieldsValue(formVars);
    this.setState(stateVars);
    KuikaAppManager.hideSpinner(this);

    return isErrorOccurred;
  };

  async callCallbackFunction(diId: number, isFromMaster: boolean = false) {
    let isErrorOccurred = false;
    let pageInitCallerNavDiIDs = [690718, 375410, 210645] as number[];
    if (isFromMaster || pageInitCallerNavDiIDs.indexOf(diId) > -1) {
      await this.YuklemeListesiv2EvrakKontrolTedarikciPageInit();
    }
    if (diId == 690718) {
      isErrorOccurred =
        await this.YuklemeListesiv2EvrakKontrolTedarikciComponent_834167_onClick1_();
      if (isErrorOccurred) return true;
    }
  }
}
